/*
    Created by Phat Pham
    phat@launchdeck.org
*/

import React, {
    useImperativeHandle,
    useMemo,
    useRef,
    useState
} from 'react';
import {
    Text,
    View,
    FlatList,
    TouchableOpacity,
    StyleSheet,
    useWindowDimensions
} from 'react-native-web';
import PropTypes from 'prop-types';

// Custom Components
import { CustomModal, NavBar } from '../components';

// Configs
import GLOBAL from '../configs/config_global';

export function SalesTaxSelector(props, ref) {
    const { width } = useWindowDimensions();

    // region Props
    const { onTaxItemSelected, taxList } = props;
    // endregion

    // region Refs
    const mainList = useRef(null);
    // endregion

    // region Local State
    const [modalVisible, setModalVisible] = useState(false);
    // endregion

    // region Function - Show/Hide Modal
    const showModal = () => setModalVisible(true);

    const hideModal = () => setModalVisible(false);
    // endregion

    // region Expose Method
    useImperativeHandle(
        ref,
        () => ({ showModal, hideModal }),
        []
    );
    // endregion

    // region Values
    const stateViewContainerWidth = useMemo(() => (width - (128 * 2) - 40), [width]);
    const imageWidth = (stateViewContainerWidth - (16 * 5)) / 5;
    // endregion

    // region Render City Item
    const renderTaxItem = (item, index) => (
        <TouchableOpacity
            key={`taxItem_${item.id}`}
            onPress={() => {
                hideModal();
                onTaxItemSelected(item);
            }}
            style={{
                width: imageWidth, height: 64, marginRight: ((index % 5 === 0) && (index % 2 !==0)) ? 0 : 16, marginTop: 16,
                backgroundColor: `rgba(0, 0, 0, ${item.id === -1 || item.id === 0 ? 0.9 : 0.5})`, alignItems: 'center', justifyContent: 'center', borderRadius: 8
            }}>
            <Text style={{ color: item.id === -1 ? GLOBAL.COLOR.BASIC.UI_BLUE : (item.id === 0 ? 'red' : 'white'), fontWeight: 'bold', fontSize: 18, marginHorizontal: 16, textAlign: 'center' }}>
                {item.name}
            </Text>
        </TouchableOpacity>
    );
    // endregion

    // region MAIN RENDER
    return(
        <CustomModal visible={modalVisible}>
            {/* Nav Bar */}
            <NavBar
                leftButtonIconName={'close'}
                leftButtonOnPress={() => hideModal()}
                title={'Sales Tax Selector'}
            />

            {/* Main Content */}
            <FlatList
                ref={mainList}
                style={{ flex: 1, width: '100%' }}
                contentContainerStyle={{ paddingBottom: 48, paddingLeft: 24 }}
                data={taxList}
                renderItem={({ item }) => renderTaxItem(item)}
                showsVerticalScrollIndicator={false}
                keyExtractor={(item) => item.id.toString()}
                numColumns={5}
            />
        </CustomModal>
    );
    // endregion
}

// Forward Ref
SalesTaxSelector = React.forwardRef(SalesTaxSelector);

// region Props
SalesTaxSelector.propTypes = {
    onTaxItemSelected: PropTypes.func,
    taxList: PropTypes.array
};

SalesTaxSelector.defaultProps = {
    onTaxItemSelected: () => {},
    taxList: []
};
// endregion
